<template lang="pug">
  transition(name="show" mode="out-in")
    ul.tree-menu(v-show="show")
      tree-menu-item(
        v-for="item in visibleItems"
        v-if="! item.disabled && ! item.hidden"
        :item="item"
        :key="item.id"
        :depth="depth"
        :max-depth="maxDepth"
        :toggle-event="toggleEvent"
        :delay="delay"
        :current="current"
        :active-ids="activeIds"
        :allow-multiple-active-items="allowMultipleActiveItems"
        :full-width-threshold="fullWidthThreshold"
        @focus="focus"
        @open="open"
      )
</template>

<script>
import { mapGetters } from 'vuex';
import TreeMenuItem from './Item';

export default {
    name: 'TreeMenu',
    data() {
        return {
            current: undefined
        };
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        depth: {
            type: Number,
            default: 1
        },
        maxDepth: {
            type: Number
        },
        show: {
            type: Boolean,
            default: true
        },
        toggleEvent: {
            type: String,
            default: 'hover'
        },
        delay: {
            type: Number,
            default: 300
        },
        allowMultipleActiveItems: {
            type: Boolean,
            default: false
        },
        fullWidthThreshold: {
            type: Number,
            default: 12
        },
        activeIds: {
            type: Array
        }
    },
    components: {
        TreeMenuItem
    },
    computed: {
        visibleItems() {
            return this.items.filter(item => {
                let visible = true;

                if (item.restriction === 'members' && !this.isAuthenticated) visible = false;
                else if (item.restriction === 'guests' && this.isAuthenticated) visible = false;
                if (item.disabled) visible = false;

                return visible;
            });
        },
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated'
        })
    },
    methods: {
        focus(item) {
            // unset timeout for recent item
            this.current = item;
        },
        open(item) {
            // close all other children
            this.current = item;
        }
    }
};
</script>

<style lang="sass" scoped></style>
